"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.form.title.edit': 'Edit Knowledge',
    'knowledge.form.title.add': 'Add Knowledge',
    'knowledge.form.back': 'Back',
    'knowledge.form.title.label': 'Title',
    'knowledge.form.title.placeholder': 'Enter knowledge title',
    'knowledge.form.description.label': 'Description',
    'knowledge.form.description.placeholder': 'Enter knowledge description',
    'knowledge.form.description.help': 'Provide a brief description to help identify this knowledge',
    'knowledge.form.content.label': 'Content',
    'knowledge.form.content.placeholder': 'Enter knowledge content',
    'knowledge.form.file.label': 'File',
    'knowledge.form.file.placeholder': 'Select file',
    'knowledge.form.project.label': 'Project',
    'knowledge.form.project.placeholder': 'Select project',
    'knowledge.form.tags.label': 'Tags',
    'knowledge.form.tags.placeholder': 'Enter tags separated by commas',
    'knowledge.form.tags.help': 'Use enter to add tags',
    'knowledge.form.contentType.label': 'Content Type',
    'knowledge.form.contentType.help': 'Select the type of content you want to add',
    'knowledge.form.contentType.text': 'Text',
    'knowledge.form.contentType.file': 'File',
    'knowledge.form.contentType.link': 'Link',
    'knowledge.form.contentType.googleDrive': 'Google Drive',
    'knowledge.form.contentType.google-drive': 'Google Drive',
    'knowledge.form.link.label': 'Link URL',
    'knowledge.form.link.placeholder': 'Enter the URL of the link',
    'knowledge.form.googleDrive.label': 'Google Drive URL',
    'knowledge.form.googleDrive.placeholder': 'Enter Google Drive share URL',
    'knowledge.form.googleDrive.selectFile': 'Select from Google Drive',
    'knowledge.form.googleDrive.notAuthenticated': 'Google Drive not connected. Please connect your account in settings.',
    'knowledge.form.googleDrive.notConnected': 'Google Drive not connected',
    'knowledge.form.googleDrive.connect': 'Connect in Settings',
    'knowledge.form.googleDrive.configureSettings': 'Configure in Settings',
    'knowledge.form.googleDrive.statusError': 'Failed to check Google Drive status',
    'knowledge.form.googleDrive.fileSelected': 'Google Drive file selected successfully',
    'knowledge.form.googleDrive.fileCleared': 'Google Drive file cleared',
    'knowledge.form.timed.label': 'Enable Time-based Availability',
    'knowledge.form.timed.help': 'Restrict when this knowledge is available to avatars',
    'knowledge.form.startTime.label': 'Start Time',
    'knowledge.form.startTime.placeholder': 'Select start date',
    'knowledge.form.endTime.label': 'End Time',
    'knowledge.form.endTime.placeholder': 'Select end date',
    'knowledge.form.active.label': 'Active',
    'knowledge.form.active.help': 'Enable this knowledge for use',
    'knowledge.form.rag_status.label': 'RAG Status',
    'knowledge.form.content_type.label': 'Content Type',
    'knowledge.form.submit.update': 'Update Knowledge',
    'knowledge.form.submit.create': 'Create Knowledge',
    'knowledge.form.reset.debug': 'Resetting form to initial state',
    'knowledge.form.reset.complete': 'Form parts reset complete',
    'knowledge.form.reset.forNext': 'Resetting form for next entry',
    'knowledge.form.projects.loadError': 'Failed to load projects:',
    'knowledge.form.load.error': 'Failed to load knowledge',
    'knowledge.form.submit.duplicateWarning': 'Form submission already in progress, ignoring duplicate submission',
    'knowledge.form.submit.starting': 'Starting form submission with data:',
    'knowledge.form.submit.updating': 'Updating knowledge with ID:',
    'knowledge.form.submit.creating': 'Creating new knowledge entry',
    'knowledge.form.submit.updateError': 'Failed to update knowledge',
    'knowledge.form.submit.createError': 'Failed to create knowledge',
    'knowledge.form.submit.updateSuccess': 'Knowledge updated successfully',
    'knowledge.form.submit.createSuccess': 'Knowledge created successfully',
    'knowledge.form.submit.success': 'Knowledge created successfully:',
    'knowledge.form.submit.error': 'Failed to save knowledge:',
    'knowledge.form.validation.fileRequired': 'File is required',
    'knowledge.form.validation.timedDatesRequired': 'Both start time and end time are required when timed is enabled',
    'knowledge.form.fileProcessing.completed': 'File processing completed successfully',
    'knowledge.form.fileProcessing.failed': 'File processing failed',
    'knowledge.form.ragOverride.title': 'Indexing Settings Override',
    'knowledge.form.ragOverride.description': 'Optionally override the default RAG indexing settings for this knowledge entry.',
};
